// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__WmEvc","header":"PatientBlock_header__3KgaL","label":"PatientBlock_label__3vYSK","option":"PatientBlock_option__1VApL"};